<template>
  <pt-lab-product-form class="pt-lab-product-form__page"></pt-lab-product-form>
</template>

<script>
import PtLabProductForm from 'cps/lab-product/pt-lab-product/pt-lab-product-form/withData'
export default {
  name: 'pt-lab-product-form__view',
  components: {
    'pt-lab-product-form': PtLabProductForm
  }
}
</script>
